export default __webpack_public_path__ + "static/media/deathlessacolytereaper.8f759cb7.png";